import { getApiClient } from './apiService'
import config from '../config/env'

const getListOfCities = async () => {
  let url = `/cities`

  try {
    const response = await getApiClient().get(url)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getListOfCities error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

export const utilityService = {
  getListOfCities,
}
